module.exports = __webpack_public_path__ + "media/pricing/Health_Care-fdc605ed.svg";